import { Injectable } from '@angular/core';
import { WebServicesService } from '../web-services/web-services.service';
import { Page } from '../web-services/page.model';
import { PagedData } from '../web-services/paged-data.model';
import { TranslateService } from '@ngx-translate/core';
import { Role } from './role.model';
import { NotificationService } from '../../service/notification/notification.service';

@Injectable({
	providedIn: 'root'
})
export class RoleService {

	constructor(
		private notificationService: NotificationService,
		private translateService: TranslateService,
		private webServicesService: WebServicesService
	) { }

	/* Appels aux webServices */

	public getRoles(page?: Page, sort?: string, dir?: string): Promise<PagedData<Role>> {
		console.log('RÃ©cupÃ©ration des rÃ´les');
		let promise: Promise<PagedData<Role>>;
		if (page) {
			if (sort && dir) {
				promise = this.webServicesService.getList<Role>('/role?size=' + page.size + '&page=' + page.number + '&sort=' + sort + ',' + dir);
			} else {
				promise = this.webServicesService.getList<Role>('/role?size=' + page.size + '&page=' + page.number);
			}
		}
		else {
			promise = this.webServicesService.getList<Role>('/role');
		}
		return promise
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ROLES.GET_ROLES_ERROR'));
				return Promise.reject(error);
			})
	}

	// TODO: Ne plus filtrer le applicationId
	public getRolesForApplication(applicationId: string): Promise<Role[]> {
		console.log('RÃ©cupÃ©ration des rÃ´les de l\'application ' + applicationId);
		return this.webServicesService.getList<Role>('/role?applicationId=' + applicationId)
			.then(pagedData => {
				if (pagedData && pagedData._embedded) {
					let roles: Role[] = pagedData._embedded[Object.keys(pagedData._embedded)[0]];
					roles.sort((a, b) => {
						if (a.name < b.name)
							return -1;
						if (a.name > b.name)
							return 1;
						return 0;
					});
					return Promise.resolve(roles.filter(role => role.applicationId === applicationId));
				}
				else return Promise.resolve([]);
			})
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('GET_ROLES_ERROR'));
				return Promise.reject(error);
			})
	}

	public postRole(role: Role): Promise<Role> {
		console.log('Ajout d\'un nouveau rÃ´le');
		let json = {
			applicationId: role.applicationId,
			name: role.name
		}
		return this.webServicesService.post<Role>('/role', json)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}

	public patchRole(role: Role): Promise<Role> {
		console.log('Modification du rÃ´le ' + role.id);
		let json = {
			applicationId: role.applicationId,
			name: role.name
		}
		return this.webServicesService.patch<Role>('/role/' + role.id, json)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}

	public deleteRole(role: Role): Promise<any> {
		console.log("Suppression du rÃ´le " + role.id);
		let json = {
			applicationId: role.applicationId,
			name: role.name
		}
		return this.webServicesService.post<Role>('/role/delete/' + role.id, json)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}

	/* Fonctions utilitaires */

	public postRoles(roles: Role[]): Promise<any> {
		let promises: Promise<Role>[] = [];
		for (let role of roles) {
			promises.push(this.postRole(role));
		}
		return Promise.all(promises);
	}
}
